export const apiBaseURL = {
    CATEGORIES: "/class",
    STRATEGY: "/strategy",
    SUB_CATEGORIES: "/sub-class",
    COUNTRIES: "/countries",
    ASSETS_DETAILS: "/assets",
    ISSUERS: "/issuers",
    ASSETS: "/assets",
    BYOD: "/custom-field",
    FINANCE_SEARCH: "/finance/search",
    FINANCE: "/finance",
    ADMIN_REGISTER: "/auth/register",
    ADMIN_LOGIN: "/auth/login",
    PORTFOLIOS: '/portfolios',
    PORTFOLIOS_COLUMN: '/portfolios-column',
    PORTFOLIOS_GROUP: '/portfolio-group',
    ALLOCATION: '/allocation',
    VIEWS: '/views',
    ALLOCATION_MONITOR: '/allocation-monitor',
    TYPES: '/types',
    SUB_TYPES: '/sub-types',
    LOGOUT: "/logout",
    PORTFOLIO_TRANSACTION: "/asset-transactions",
    CUSTOM_FIELD_DATA: "/custom-field-data",
    CUSTOM_FIELD_VALUE: "/custom-field-value",
    CUSTOM_FIELD: "/custom-field",
    ASSET_ISSUER_CUSTOM_FIELD: "/asset-issuer-custom-fields",
    FILE_UPLOAD: '/files/upload',
    FILE: '/files',
    USER: '/user',
    POLICY_TEMPLATE: '/policy/templates',
    POLICY_FORMS: '/policy/forms',
    POLICY_WORKFLOW: '/policy/workflow',
    POLICY_TAG: '/policy/tags',
    POLICY_SHARED: '/policy/shared',
    POLICY_FORM_SEND: '/policy/forms',
    POLICY_FORM_SHARE: '/share',
    POLICY_FORM_ASSOCIATIONS: '/associations',
    POLICY_FORM_VOID: '/void',
    POLICY_FORM_ISSUE: '/issue',
    POLICY_LOGO: '/policy/logo',
    POLICY_ALLOCATION_DATA: '/policy/allocation-data',
    CLIENTS: '/clients',
    // admin baseurl
    ADMIN_USER: '/admin/users',
    ADMIN_CLASS: "/admin/class",
    ADMIN_SUB_CLASS: "/admin/sub-class",
    ADMIN_TYPE: "/admin/types",
    ADMIN_SUB_TYPE: "/admin/sub-types",
    CURVE: "/yield-curves",
    TENOR: "/tenor",
    PRICE_HIERARCHY: "/price-hierarchy",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    TOLERANCE_PARAMETER: "/tolerance-parameter",
    GET_FIELDS: "/custom-field/quantitative",
    ASSIGN_PARAMETER_TO_PORTFOLIO: "/tolerance-parameter/asset-portfolio",
    MONITOR_TOLERANCE_PARAMETER: "/tolerance-parameter/get-tolerance-portfolios",
    GET_PORTFOLIO_BY_PARAMETER_ID: "/tolerance-parameter/get-portfolio",
    TOLERANCE_ALERTS: "/tolerance-alerts",
    NEW_ALLOCATION: "/allocation/assets-allocation-v2",
    DATA_LOAD_TYPE: "/data-load-type",
    API_KEY: '/user/api-key',
    GENERATE_API_KEY: '/user/generate-api-key',
    API_KEYS: '/user/api-keys', // W75 (API-001)
    // IPM (W0-W2): organisation context, rule library, monitoring
    ORGANISATION_ME: '/organisation/me',
    // organisation / notifications / exit / profile / search pages
    ORGANISATION: '/organisation',
    NOTIFICATIONS: '/notifications',
    EXIT: '/exit',
    USER_MFA: '/user/mfa',
    SEARCH: '/search',
    AUTH_STEP_UP: '/auth/step-up',
    META: '/meta',
    GOVERNANCE_EPISODES: '/governance/episodes',
    ENTITIES: '/entities',
    RULES: '/rules',
    RULE_TEMPLATES: '/rules/templates',
    RULE_FORMULA_PRIMITIVES: '/rules/formula/primitives',
    // W17 (EXP-002): the per-rule FX-policy override form, rendered from data.
    RULE_FX_POLICY: '/rules/fx-policy',
    RULE_FORMULA_CHECK: '/rules/formula/check',
    RULE_VERSIONS: '/rules/versions',
    MONITORING_RUNS: '/monitoring/runs',
    MONITORING_RESULTS: '/monitoring/results',
    MONITORING_COVERAGE: '/monitoring/coverage',
    MONITORING_DASHBOARD: '/monitoring/dashboard',
    MONITORING_PORTFOLIO_STATUS: '/monitoring/portfolio-status',
    MONITORING_EXPOSURE: '/monitoring/exposure',
    MONITORING_HEADROOM: '/monitoring/headroom',
    MONITORING_RESULT_TREND: '/monitoring/results/trend',
    // compliance pages
    MONITORING_WHAT_IF: '/monitoring/what-if',
    RULE_MONITORING_TRIGGERS: '/rules/monitoring-triggers',
    AI_GOVERNANCE: '/ai/governance',
    AI_POLICY_COMPARISON: '/ai/policy-comparison',
    AI_DATA_USE: '/ai/data-use',
    AI_EXPLAIN_RESULT: '/ai/explain/result',
    DOCUMENTS: '/documents',
    GOVERNANCE: '/governance',
    DATA_QUALITY: '/data-quality',
    DATA_FEEDS: '/data-feeds',
    FX: '/fx',
    INSTRUMENTS: '/instruments',
    INGEST: '/ingest',
    REFERENCE: '/reference',
    TRADE_IMPACT: '/trade-impact',
    REPORTS: '/reports',
    AUDIT: '/audit',
    OPS_STATUS: '/ops/status',
    SAVED_VIEWS: '/saved-views',
    TRACE: '/trace',
    // W117: the manager's analysis (the Investment workspace's Analysis page).
    ANALYSIS: '/analysis',
    ANALYSIS_SCOPES: '/analysis/scopes',
};
export const authActionType = {
    LOGIN_ADMIN: 'LOGIN_ADMIN',
    LOGOUT: 'LOGOUT',
    REGISTER: 'REGISTER'
};

export const Tokens = {
    ADMIN_TOKEN: 'auth_token',
    STEP_UP_TOKEN: 'step_up_token', // W107 (§18): the short-lived proof of presence
    ADMIN: 'admin',
    ADMIN_ROLE: 'role'
};

export const errorMessage = {
    TOKEN_NOT_PROVIDED: 'Token not provided',
    TOKEN_EXPIRED: 'Token has expired',
    TOKEN_INVALID_AUTH: 'Invalid authentication Token',
    TOKEN_INVALID: 'Could not decode token: Error while decoding to JSON: Syntax error',
    TOKEN_INVALID_SIGNATURE: 'Token Signature could not be verified.',
    NOT_AUTHENTICATED: 'Not authenticated.'
};

export const toastifyType = {
    SHOW_TOAST: 'SHOW_TOAST',
    SHOW_SUCCESS_MESSAGE: 'SHOW_SUCCESS_MESSAGE',
    SHOW_ERROR_MESSAGE: 'SHOW_ERROR_MESSAGE'
}

export const constants = {
    SET_TOTAL_RECORD: 'SET_TOTAL_RECORD',
    IS_LOADING: 'IS_LOADING',
    IS_UPDATE_STATE: 'IS_UPDATE_STATE',
    IS_META: 'IS_META'
};

export const classActionType = {
    FETCH_CLASSES: 'FETCH_CLASSES',
    FETCH_CLASS: 'FETCH_CLASS',
    ADD_CLASS: 'ADD_CLASS',
    UPDATE_CLASS: 'UPDATE_CLASS',
    DELETE_CLASS: 'DELETE_CLASS',
};

export const organisationActionType = {
    FETCH_ORGANISATION_ME: 'FETCH_ORGANISATION_ME',
    FETCH_ORGANISATION_ME_FAILED: 'FETCH_ORGANISATION_ME_FAILED',
};

export const rulesActionType = {
    FETCH_RULE_TEMPLATES: 'FETCH_RULE_TEMPLATES',
    FETCH_RULES: 'FETCH_RULES',
    FETCH_RULE: 'FETCH_RULE',
};

export const monitoringActionType = {
    FETCH_MONITORING_RUNS: 'FETCH_MONITORING_RUNS',
    FETCH_MONITORING_RESULTS: 'FETCH_MONITORING_RESULTS',
    FETCH_MONITORING_COVERAGE: 'FETCH_MONITORING_COVERAGE',
};

export const strategyActionType = {
    FETCH_STRATEGIES: 'FETCH_STRATEGIES',
    FETCH_STRATEGY: 'FETCH_STRATEGY',
    ADD_STRATEGY: 'ADD_STRATEGY',
    UPDATE_STRATEGY: 'UPDATE_STRATEGY',
    DELETE_STRATEGY: 'DELETE_STRATEGY',
};

export const portfoliosActionType = {
    FETCH_PORTFOLIOS: 'FETCH_PORTFOLIOS',
    FETCH_PORTFOLIOS_ALL: 'FETCH_PORTFOLIOS_ALL',
    FETCH_PORTFOLIO: 'FETCH_PORTFOLIO',
    ADD_PORTFOLIO: 'ADD_PORTFOLIO',
    UPDATE_PORTFOLIO: 'UPDATE_PORTFOLIO',
    DELETE_PORTFOLIO: 'DELETE_PORTFOLIO',
};

export const portfoliosGroupActionType = {
    FETCH_PORTFOLIOS_GROUPS: 'FETCH_PORTFOLIOS_GROUPS',
    FETCH_PORTFOLIO_GROUP: 'FETCH_PORTFOLIO_GROUP',
    ADD_PORTFOLIO_GROUP: 'ADD_PORTFOLIO_GROUP',
    UPDATE_PORTFOLIO_GROUP: 'UPDATE_PORTFOLIO_GROUP',
    DELETE_PORTFOLIO_GROUP: 'DELETE_PORTFOLIO_GROUP',
    FETCH_PORTFOLIOS_GROUP_Asset: 'FETCH_PORTFOLIOS_GROUP_Asset',
};

export const subClassActionType = {
    FETCH_SUB_CLASSES: 'FETCH_SUB_CLASSES',
    FETCH_SUB_CLASS: 'FETCH_SUB_CLASS',
    ADD_SUB_CLASS: 'ADD_SUB_CLASS',
    UPDATE_SUB_CLASS: 'UPDATE_SUB_CLASS',
    DELETE_SUB_CLASS: 'DELETE_SUB_CLASS',
};

export const countriesActionType = {
    FETCH_COUNTRIES: 'FETCH_COUNTRIES',
    FETCH_COUNTRIE: 'FETCH_COUNTRIE',
    ADD_COUNTRIES: 'ADD_COUNTRIES',
    UPDATE_COUNTRIES: 'UPDATE_COUNTRIES',
    DELETE_COUNTRIES: 'DELETE_COUNTRIES',
};

export const assetsDetailsActionType = {
    FETCH_ASSETS_DETAILS: 'FETCH_ASSETS_DETAILS',
    FETCH_ASSETS_DETAILS_ADDED: 'FETCH_ASSETS_DETAILS_ADDED',
    FETCH_ASSETS_DETAIL: 'FETCH_ASSETS_DETAIL',
    ADD_ASSETS_DETAIL: 'ADD_ASSETS_DETAIL',
    UPDATE_ASSETS_DETAIL: 'UPDATE_ASSETS_DETAIL',
    DELETE_ASSETS_DETAIL: 'DELETE_ASSETS_DETAIL',
};

export const assetsDetailsV2ActionType = {
    FETCH_ASSETS_DETAILS_V2: 'FETCH_ASSETS_DETAILS_V2',
    FETCH_ASSETS_DETAIL_V2: 'FETCH_ASSETS_DETAIL_V2',
    ADD_ASSETS_DETAIL_V2: 'ADD_ASSETS_DETAIL_V2',
    UPDATE_ASSETS_DETAIL_V2: 'UPDATE_ASSETS_DETAIL_V2',
    DELETE_ASSETS_DETAIL_V2: 'DELETE_ASSETS_DETAIL_V2',
    FETCH_ASSETS_HISTORY_V2: 'FETCH_ASSETS_HISTORY_V2',
    FETCH_ASSETS_BY_ISSUER_V2: 'FETCH_ASSETS_BY_ISSUER_V2',

};

export const issuerActionType = {
    FETCH_ISSUER: 'FETCH_ISSUER',
    FETCH_ISSUER_V2: 'FETCH_ISSUER_V2',
    ADD_ISSUER: 'ADD_ISSUER',
    UPDATE_ISSUER: 'UPDATE_ISSUER',
    DELETE_ISSUER: 'DELETE_ISSUER',
    FETCH_ISSUER_HISTORY: 'FETCH_ISSUER_HISTORY',
};

export const clientActionType = {
    FETCH_CLIENTS: 'FETCH_CLIENTS',
};

export const byodActionType = {
    FETCH_BYOD_V2: 'FETCH_BYOD_V2',
    FETCH_BYOD_VALUE_V2: 'FETCH_BYOD_VALUE_V2',
    FETCH_BYOD_VALUE2_V2: 'FETCH_BYOD_VALUE2_V2',
    ADD_BYOD_V2: 'ADD_BYOD_V2',
};

export const assetsFinanceSearchActionType = {
    FETCH_FINANCE_SEARCH_V2: 'FETCH_FINANCE_SEARCH_V2',
};

export const financePriceActionType = {
    FETCH_FINANCE_PRICE_V2: 'FETCH_FINANCE_PRICE_V2',
    GET_FINANCE_PRICE_V2: 'GET_FINANCE_PRICE_V2',
};

export const financeExchangesActionType = {
    FETCH_FINANCE_EXCHANGES_V2: 'FETCH_FINANCE_EXCHANGES_V2',
};

export const allocationsActionType = {
    FETCH_ALLOCATIONS: 'FETCH_ALLOCATIONS',
    FETCH_ALLOCATION: 'FETCH_ALLOCATION',
    ADD_ALLOCATION: 'ADD_ALLOCATION',
    UPDATE_ALLOCATION: 'UPDATE_ALLOCATION',
    DELETE_ALLOCATION: 'DELETE_ALLOCATION',
    HISTORY_ALLOCATION: 'HISTORY_ALLOCATION',
    FETCH_ALLOCATIONS_DETAILS: 'FETCH_ALLOCATIONS_DETAILS',
};

export const allocationsV2ActionType = {
    ADD_ALLOCATION_V2: 'ADD_ALLOCATION_V2',
    GET_ALLOCATED_PORTFOLIOS_V2: 'GET_ALLOCATED_PORTFOLIOS_V2',
    GET_ALLOCATED_AUTHORIZED_ASSETS_V2: 'GET_ALLOCATED_AUTHORIZED_ASSETS_V2',
    DELETE_ASSET_ALLOCATIONS: 'DELETE_ASSET_ALLOCATIONS',
    LOCK_UNLOCK_ASSET_ALLOCATION: 'LOCK_UNLOCK_ASSET_ALLOCATION'
}

export const allocationsMonitorActionType = {
    FETCH_ALLOCATIONS_MONITOR: 'FETCH_ALLOCATIONS_MONITOR',
    FETCH_ALLOCATION_MONITOR: 'FETCH_ALLOCATION_MONITOR',
    ADD_ALLOCATION_MONITOR: 'ADD_ALLOCATION_MONITOR',
    UPDATE_ALLOCATION_MONITOR: 'UPDATE_ALLOCATION_MONITOR',
    DELETE_ALLOCATION_MONITOR: 'DELETE_ALLOCATION_MONITOR',
};
export const curveActionType = {
    FETCH_CURVES: 'FETCH_CURVES',
};
export const tenorActionType = {
    FETCH_TENOR: 'FETCH_TENOR',
};

export const viewsActionType = {
    FETCH_VIEWS: 'FETCH_VIEWS',
    FETCH_VIEWS_NEW: 'FETCH_VIEWS_NEW',
    CUSTOM_FIELD: 'CUSTOM_FIELD',
    FETCH_VIEW: 'FETCH_VIEW',
    ADD_VIEW: 'ADD_VIEW',
    UPDATE_VIEW: 'UPDATE_VIEW',
    DELETE_VIEW: 'DELETE_VIEW',
};

export const customFieldsDataType = {
    FETCH_CUSTOM_DATA: 'FETCH_CUSTOM_DATA'
}

export const portfolioActionType = {
    FETCH_portfolio_V2: 'FETCH_portfolio_V2',
    ADD_portfolio_V2: 'ADD_portfolio_V2',
    UPDATE_portfolio_V2: 'UPDATE_portfolio_V2',
    DELETE_portfolio_V2: 'DELETE_portfolio_V2',
};

export const assetsAuthorizeActionType = {
    FETCH_ASSETS_AUTHORIZE_V2: 'FETCH_ASSETS_AUTHORIZE_V2',
    ADD_ASSETS_AUTHORIZE_V2: 'ADD_ASSETS_AUTHORIZE_V2',
    UPDATE_ASSETS_AUTHORIZE_V2: 'UPDATE_ASSETS_AUTHORIZE_V2',
    DELETE_ASSETS_AUTHORIZE_V2: 'DELETE_ASSETS_AUTHORIZE_V2',
};

export const viewDocFileActionType = {
    VIEW_DOC_FILE: 'VIEW_DOC_FILE',
}

export const portfolioColumnActionType = {
    FETCH_PORTFOLIOS_COLUMN: 'FETCH_PORTFOLIOS_COLUMN',
    FETCH_PORTFOLIOS_GROUP_COLUMN: 'FETCH_PORTFOLIOS_GROUP_COLUMN',
    FETCH_ALLOCATION_COLUMN: 'FETCH_ALLOCATION_COLUMN',
    FETCH_ALLOCATION_GROUP_COLUMN: 'FETCH_ALLOCATION_GROUP_COLUMN',
};

export const typeActionType = {
    FETCH_TYPES: 'FETCH_TYPES',
    ADD_TYPES: 'ADD_TYPES',
    DELETE_TYPES: 'DELETE_TYPES',
    UPDATE_TYPES: 'UPDATE_TYPES',
};
export const subTypeActionType = {
    FETCH_SUBTYPES: 'FETCH_SUBTYPES',
    FETCH_SUBTYPE: 'FETCH_SUBTYPE',
    ADD_SUBTYPES: 'ADD_SUBTYPES',
    DELETE_SUBTYPES: 'DELETE_SUBTYPES',
    UPDATE_SUBTYPES: 'UPDATE_SUBTYPES',
};

export const AdminUserActionType = {
    FETCH_USERS: 'FETCH_USERS',
    FETCH_USER: 'FETCH_USER',
    ADD_USER: 'ADD_USER',
    UPDATE_USER: 'UPDATE_USER',
    DELETE_USER: 'DELETE_USER',
    VERIFY_USER: 'VERIFY_USER',
};

export const adminClassActionType = {
    FETCH_CLASSES: 'FETCH_CLASSES',
    FETCH_CLASS: 'FETCH_CLASS',
    ADD_CLASS: 'ADD_CLASS',
    UPDATE_CLASS: 'UPDATE_CLASS',
    DELETE_CLASS: 'DELETE_CLASS',
};
export const adminSubClassActionType = {
    FETCH_SUB_CLASSES: 'FETCH_SUB_CLASSES',
    FETCH_SUB_CLASS: 'FETCH_SUB_CLASS',
    ADD_SUB_CLASS: 'ADD_SUB_CLASS',
    UPDATE_SUB_CLASS: 'UPDATE_SUB_CLASS',
    DELETE_SUB_CLASS: 'DELETE_SUB_CLASS',
};
export const adminTypeActionType = {
    FETCH_TYPES: 'FETCH_TYPES',
    ADD_TYPES: 'ADD_TYPES',
    DELETE_TYPES: 'DELETE_TYPES',
    UPDATE_TYPES: 'UPDATE_TYPES',
};
export const adminSubTypeActionType = {
    FETCH_SUBTYPES: 'FETCH_SUBTYPES',
    FETCH_SUBTYPE: 'FETCH_SUBTYPE',
    ADD_SUBTYPES: 'ADD_SUBTYPES',
    DELETE_SUBTYPES: 'DELETE_SUBTYPES',
    UPDATE_SUBTYPES: 'UPDATE_SUBTYPES',
};
export const PortfolioTransactionActionType = {
    FETCH_INVESTED_ASSETS: 'FETCH_INVESTED_ASSETS',
    FETCH_INVESTED_ASSET: 'FETCH_INVESTED_ASSET',
    UPDATE_INVESTED_ASSETS: 'UPDATE_INVESTED_ASSETS',
    DELETE_INVESTED_ASSETS: 'DELETE_INVESTED_ASSETS',
    ADD_INVESTED_ASSETS: 'ADD_INVESTED_ASSETS',
};

export const saleTransactionActionType = {
    FETCH_INVESTED_ASSETS_SALE: 'FETCH_INVESTED_ASSETS_SALE',
};

export const profileActionType = {
    GET_PROFILE_INFO: 'GET_PROFILE_INFO',
    CHANGE_PROFILE_PASSWORD: 'CHANGE_PROFILE_PASSWORD'
}

export const priceHierarchyActionType = {
    FETCH_PRICE_HIERARCHY: 'FETCH_PRICE_HIERARCHY',
    ADD_PRICE_HIERARCHY: 'ADD_PRICE_HIERARCHY',
    UPDATE_PRICE_HIERARCHY: 'UPDATE_PRICE_HIERARCHY',
    DELETE_PRICE_HIERARCHY: 'DELETE_PRICE_HIERARCHY',
    FETCH_BYOD_V2: 'FETCH_BYOD_V2',
};

export const Filters = {
    PAGE: 1,
    OBJ: {
        totalRecords: 0,
        totalPages: 0,
        page: 1,
        perPage: 10,
        direction: 'asc',
        search: '',
        adminName: 'admin',
        categoryId: '',
        created_at: 'created_at',
        status: '',
        payment_status: '',
        payment_type: '',
        product_unit: '',
        base_unit: ''
    }
};
/**
 * How a portfolio receives its holdings.
 *
 * Position-based rows state the holding on their date; Transaction-based rows
 * state a movement that accumulates. Previously "Flush & Fill" and
 * "Transactional" — the server still accepts those names and normalises them.
 */
export const dataLoadType = {
    POSITION_BASED: 'Position-based',
    TRANSACTION_BASED: 'Transaction-based',
};
